var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.isLoading)?_c('div',{staticClass:"loader-container"},[_c('le-loader',{staticClass:"spinner",attrs:{"size":40}})],1):_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }